import { IAuthState, IAuthStateFulfilled, IStateRejected, IUserProfile } from '../../interfaces';
import { authAction } from '../actions';

const findOneCookie = () => {
  const { pending, fulfilled, rejected } = authAction.findOneCookie;
  return {
    // Pending
    [pending.type]: (state: IAuthState): IAuthState => ({
      ...state,
      status: 'loading',
      error: '',
    }),
    // Fulfilled
    [fulfilled.type]: (state: IAuthState, action: IAuthStateFulfilled): IAuthState => ({
      ...state,
      status: 'success',
      accessToken: action.payload as string,
      error: '',
    }),
    // Rejected
    [rejected.type]: (state: IAuthState, action: IStateRejected): IAuthState => ({
      ...state,
      accessToken: null,
      status: 'error',
      error: action.error.message,
    }),
  };
};

const findUserProfile = () => {
  const { pending, fulfilled, rejected } = authAction.findUserProfile;
  return {
    // Pending
    [pending.type]: (state: IAuthState): IAuthState => ({
      ...state,
      status: 'loading',
      error: '',
    }),
    // Fulfilled
    [fulfilled.type]: (state: IAuthState, action: IAuthStateFulfilled): IAuthState => ({
      ...state,
      userProfile: action.payload as IUserProfile,
      status: 'success',
      error: '',
    }),
    // Rejected
    [rejected.type]: (state: IAuthState, action: IStateRejected): IAuthState => ({
      ...state,
      userProfile: null,
      status: 'error',
      error: action.error.message,
    }),
  };
};

export default {
  ...findOneCookie(),
  ...findUserProfile(),
};
